import store from '@/store'

export default function isServerOffline(serverName) {
  const currentBucket = store.getters.currentBucket
  const server = currentBucket.servers.find(s => s.server_name === serverName)
  return !server.active
}
